<template>
  <div class="logo_container" ref="logoContainer">
    <a href="#" @click="navFuntions.activeSection('home')">
      <div class="animated_logo">
        <svg viewBox="0 0 120 60" xmlns="http://www.w3.org/2000/svg" class="code_logo">
          <!-- Sol köşeli parantez < -->
          <path class="bracket left-bracket" d="M35 10 L10 30 L35 50" 
                fill="none" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
          
          <!-- Sağ köşeli parantez > -->
          <path class="bracket right-bracket" d="M85 10 L110 30 L85 50" 
                fill="none" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
          
          <!-- Ortadaki slash / -->
          <path class="slash" d="M70 8 L50 52" 
                fill="none" stroke-width="6" stroke-linecap="round"/>
          
          <!-- Yörüngede dönen noktalar -->
          <g class="orbit orbit1">
            <circle class="dot" cx="60" cy="30" r="3" transform="translate(-35, 0)"/>
          </g>
          <g class="orbit orbit2">
            <circle class="dot" cx="60" cy="30" r="3" transform="translate(35, 0)"/>
          </g>
        </svg>
      </div>
    </a>
  </div>
</template>

<script>
import { navFuntions } from "@/navFuntions";

export default {
  name: "LogoComponent",
  data() {
    return {
      navFuntions,
    };
  },
};
</script>

<style scoped>
.logo_container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo_container a {
  pointer-events: auto;
  display: block;
}

.animated_logo {
  width: 120px;
  height: 60px;
}

.code_logo {
  width: 100%;
  height: 100%;
  overflow: visible;
}

/* Ana renkle entegre */
.bracket {
  stroke: var(--main-color, #00D4BD);
  filter: drop-shadow(0 0 8px var(--main-color, #00D4BD));
  animation: pulse 2s ease-in-out infinite;
}

.slash {
  stroke: #fff;
  opacity: 0.9;
  animation: slash-glow 2s ease-in-out infinite;
}

.dot {
  fill: var(--main-color, #00D4BD);
  filter: drop-shadow(0 0 4px var(--main-color, #00D4BD));
}

/* Yörünge animasyonu */
.orbit {
  transform-origin: 60px 30px;
  animation: orbit-rotate 4s linear infinite;
}

.orbit1 {
  animation-direction: normal;
}

.orbit2 {
  animation-direction: reverse;
  animation-delay: -2s;
}

.left-bracket {
  animation-delay: 0s;
}

.right-bracket {
  animation-delay: 0.3s;
}

/* Animasyonlar */
@keyframes pulse {
  0%, 100% {
    filter: drop-shadow(0 0 5px var(--main-color, #00D4BD));
    opacity: 0.9;
  }
  50% {
    filter: drop-shadow(0 0 15px var(--main-color, #00D4BD));
    opacity: 1;
  }
}

@keyframes slash-glow {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

@keyframes orbit-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Hover efekti */
.logo_container a:hover .bracket {
  filter: drop-shadow(0 0 20px var(--main-color, #00D4BD));
}

.logo_container a:hover .orbit {
  animation-duration: 1.5s;
}
</style>
